import * as React from 'react'
import cx from 'classnames'

import { ChevronLeftIcon, ChevronRightIcon } from '@toasttab/buffet-pui-icons'
import { useRestaurant } from '@local/do-secundo-restaurant-provider'

import { trackPromoBannerSeen } from '../utils'
import { TypeAwareBanner } from '../Banner'

import { PromoBanner } from '../@types'

export type PromoBannerCarouselProps = {
  banners: PromoBanner[]
  testId: string
}

export const PromoBannerCarousel = ({
  banners,
  testId
}: PromoBannerCarouselProps) => {
  const { restaurantGuid } = useRestaurant()
  const hasMultipleBanners = banners.length > 1
  const [visibleBannerIndex, setVisibleBannerIndex] = React.useState(0)
  const visibleBanner = banners[visibleBannerIndex]

  React.useEffect(() => {
    trackPromoBannerSeen(visibleBanner, restaurantGuid)
  }, [restaurantGuid, visibleBanner])

  return (
    <div
      className={cx('flex flex-row mb-6 xl:mb-9', {
        'mx-5 xl:ml-2 xl:mr-3': !hasMultipleBanners
      })}
    >
      {hasMultipleBanners && (
        <button
          className='p-0 m-0 border-0 bg-transparent cursor-pointer w-8'
          data-testid={`${testId}-previous-button`}
          onClick={() => {
            setVisibleBannerIndex(
              visibleBannerIndex <= 0
                ? banners.length - 1
                : visibleBannerIndex - 1
            )
          }}
        >
          <ChevronLeftIcon />
        </button>
      )}
      <TypeAwareBanner banner={visibleBanner} testId={testId} />
      {hasMultipleBanners && (
        <button
          className='p-0 m-0 border-0 bg-transparent cursor-pointer w-8'
          data-testid={`${testId}-next-button`}
          onClick={() =>
            setVisibleBannerIndex((visibleBannerIndex + 1) % banners.length)
          }
        >
          <ChevronRightIcon />
        </button>
      )}
    </div>
  )
}
